export const overrideOrderAttributesWithProfileExtra = (orderAttributes, userProfileExtraAttributes) => {
    if (!userProfileExtraAttributes) {
        return orderAttributes;
    }
    return orderAttributes.map((attribute) => {
        const attributeValueFromProfileExtra = userProfileExtraAttributes[attribute.attribute_code];
        if (Object.hasOwn(userProfileExtraAttributes, attribute.attribute_code) && !!attributeValueFromProfileExtra) {
            return { ...attribute, value: attributeValueFromProfileExtra };
        }
        return attribute;
    });
};
//# sourceMappingURL=overrideOrderAttributesWithProfileExtra.js.map